import HomePage from './home'
//import LoginPage from './login'
// import Page from './equipment/equipBrief'
export default HomePage
